import { InformationHoverIcon } from "./InformationHoverIcon";
import { formatDecimal } from "@/utils";

type EmployeeMetricDatum = {
  employeeName: string;
  count: number;
  percentageOfTotal: number;
};

type Props = {
  data: EmployeeMetricDatum[];
  colSpan?: number;
  title?: string;
  subtitle?: string;
  emptyMessage?: string;
  info?: string;
};

const EmployeeMetricCard = ({
  data,
  colSpan = 1,
  title,
  subtitle = "Total por asesor en el período seleccionado",
  emptyMessage = "Sin datos en este período",
  info,
}: Props) => {
  const maxCount = data.reduce((max, row) => Math.max(max, row.count), 0);

  return (
    <div style={{ gridColumn: `span ${colSpan}` }}>
      <div className="h-full rounded-2xl border border-border bg-card p-6">
        {(title || subtitle) && (
          <div className="mb-4">
            {title && (
              <div className="flex items-center gap-1">
                <h3 className="text-sm font-semibold text-palomma-secondary">{title}</h3>
                {info && <InformationHoverIcon information={info} />}
              </div>
            )}
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
        )}

        {data.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground">{emptyMessage}</p>
        ) : (
          <ul className="divide-y divide-border">
            {data.map((row) => {
              const barWidth = maxCount === 0 ? 0 : (row.count / maxCount) * 100;

              return (
                <li key={row.employeeName} className="py-3">
                  <div className="flex items-center justify-between gap-4">
                    <span className="flex-1 truncate text-sm text-palomma-secondary">
                      {row.employeeName}
                    </span>
                    <span className="text-sm tabular-nums text-muted-foreground">
                      {formatDecimal(row.percentageOfTotal, 1)}%
                    </span>
                    <span className="w-8 text-right text-sm font-semibold tabular-nums text-palomma-secondary">
                      {row.count}
                    </span>
                  </div>
                  <div className="mt-2 h-1 overflow-hidden rounded-full bg-muted">
                    <div
                      className="h-full rounded-full bg-palomma-primary"
                      style={{ width: `${barWidth}%` }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default EmployeeMetricCard;
